// Where to go after logging in. The login page takes it from its `redirect` query
// (/uye/giris?redirect=/uye/odeme); sign-up keeps it in the browser instead, because the
// way back from sign-up is the e-mail verification link, which drops the query.

const PENDING_KEY = 'post_login_redirect'
const PENDING_DAYS = 7

// Only a path inside the app: '//host' and '/\host' would leave it, and spaces or
// control characters have no place in one.
export function safeRedirect (value) {
  if (typeof value !== 'string') return null
  if (!value.startsWith('/') || value.startsWith('//')) return null
  if (value.split('').some(char => char <= ' ' || char === '\\')) return null
  return value
}

// The query that carries the redirect over to the next membership page, or none.
export function redirectQuery (query) {
  const redirect = safeRedirect(query.redirect)
  return redirect ? { redirect } : {}
}

// Keeps the redirect for the login that follows the e-mail verification, for that
// e-mail only: someone else logging in on the same browser goes to the home page.
export function rememberRedirect (value, email) {
  const path = safeRedirect(value)
  if (!path || !email) return
  try {
    window.localStorage.setItem(
      PENDING_KEY,
      JSON.stringify({ path, email: email.toLowerCase(), at: Date.now() })
    )
  } catch (error) {
    // Storage blocked: the user lands on the home page after login instead.
  }
}

function takePending (email) {
  try {
    const pending = JSON.parse(window.localStorage.getItem(PENDING_KEY))
    window.localStorage.removeItem(PENDING_KEY)
    if (
      pending &&
      pending.email === email.toLowerCase() &&
      Date.now() - pending.at < PENDING_DAYS * 24 * 60 * 60 * 1000
    ) {
      return safeRedirect(pending.path)
    }
  } catch (error) {
    // Storage blocked or the value is not ours.
  }
  return null
}

// The page to open after `email` logged in; a remembered redirect is used once.
export function takeRedirect (query, email) {
  const pending = takePending(email)
  return safeRedirect(query.redirect) || pending
}
